<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="isSmallScreen ? '30px' : '24px'" :height="isSmallScreen ? '30px' : '24px'" viewBox="0 0 24 24" fill="none" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-check-icon lucide-file-check">
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
    <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
    <path d="m9 15 2 2 4-4"/>
  </svg>
</template>
<script lang="ts">
import {useScreenSize} from "@/composable/useScreenSize.js";
import {useCommonStore} from "@/stores/common";
import {watch, ref} from "vue";
export default {
  name: 'IconInvoice',
  setup() {
    const { width, isSmallScreen } = useScreenSize(1024);
    const commonStore = useCommonStore()
    const color = ref('#3a3a3a')
    watch(() => (commonStore.settings.icons as Record<string, boolean>)?.['IconInvoice'], (newStatus) => {
      color.value = newStatus ? '#3cc89e' : '#3a3a3a'
    });

    return {
      width,
      color,
      isSmallScreen,
    }
  }
}
</script>